import React from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import { Text } from 'ui/bend'

const EmptyText = styled(Text)`
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
`

const LinkToClassFinder = styled(Text)`
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
  text-decoration-line: underline;
`

const EmptyPlaylist = ({
}) => {
  
  return (
    <Flex
      flexDirection='column'
      gap='8px'
      flex='1'
    >
      <EmptyText>This playlist is empty</EmptyText>
      <Flex 
        as='a'
        href={'/class-finder'}>
        <LinkToClassFinder>Find Classes to Add</LinkToClassFinder>
      </Flex>
    </Flex>
  )
}
EmptyPlaylist.propTypes = {
}

export default EmptyPlaylist
